(function () {
  'use strict';

  function initScripts() {
    // 1. COLLECTION TOGGLE
    document.querySelectorAll('.collection-desc').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      // Dawn's description is often wrapped inside a rich-text or collection__description
      const description = section.querySelector('.rich-text__text, .collection__description, .rte');
      if (!description) return;

      const collapsedHeight = 100;
      if (description.scrollHeight <= collapsedHeight) return;

      description.style.maxHeight = collapsedHeight + 'px';
      description.style.overflow = 'hidden';
      description.style.transition = 'max-height .3s ease';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'collection-description-toggle';
      button.textContent = 'Read more';
      // Append directly to the section
      section.appendChild(button);

      button.addEventListener('click', function () {
        const isExpanded = description.classList.toggle('expanded');
        description.style.maxHeight = isExpanded ? description.scrollHeight + 'px' : collapsedHeight + 'px';
        button.textContent = isExpanded ? 'Read less' : 'Read more';
      });

      section.dataset.initialized = 'true';
      console.log('Collection Toggle Initialized');
    });

    // 2. FAQ TOGGLE
    document.querySelectorAll(".toggle-faq").forEach(function (faqSection) {
      // Find the actual container inside Dawn's collapsible content
      const faqWrapper = faqSection.querySelector(".collapsible-content__inner, .collapsible-content-wrapper-narrow, .rte");
      if (!faqWrapper || faqWrapper.querySelector(".faq-toggle-trigger")) return;

      const toggle = document.createElement("div");
      toggle.className = "faq-toggle-trigger";
      toggle.textContent = "Show FAQs";
      toggle.setAttribute("role", "button");
      toggle.setAttribute("tabindex", "0");
      faqWrapper.insertBefore(toggle, faqWrapper.firstChild);

      const faqItems = Array.from(faqWrapper.children).filter(item => item !== toggle);
      faqItems.forEach(item => item.style.display = "none");

      toggle.addEventListener("click", function() {
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        faqItems.forEach(item => item.style.display = isExpanded ? "none" : "");
        toggle.setAttribute("aria-expanded", String(!isExpanded));
        toggle.textContent = isExpanded ? "Show FAQs" : "Hide FAQs";
      });
      console.log('FAQ Toggle Initialized');
    });
  }

  // Use a MutationObserver to watch for when Dawn injects content
  const observer = new MutationObserver(initScripts);
  observer.observe(document.body, { childList: true, subtree: true });

  initScripts();
})();